import _extends from "@babel/runtime/helpers/extends";
/**
 * This file generated by Stencil generateIcons scripts
 * DO NOT EDIT DIRECTLY
 */

import React from 'react';
import { withIconProps } from '../utils/withIconProps';
import { jsx as ___EmotionJSX } from "@emotion/react";
const IconCheckCircleFillMedium = withIconProps(props => {
  return ___EmotionJSX("svg", _extends({
    width: "24px",
    height: "24px",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), ___EmotionJSX("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM18.6 9.19994C19.2628 8.31628 19.0837 7.06268 18.2 6.39994C17.3164 5.73719 16.0628 5.91628 15.4 6.79994L10.8686 12.8418L8.49483 10.1712C7.76099 9.34564 6.49685 9.27128 5.67128 10.0051C4.84572 10.739 4.77136 12.0031 5.50519 12.8287L9.50519 17.3287C9.90403 17.7774 10.4833 18.0232 11.0831 17.9982C11.6829 17.9733 12.2398 17.6802 12.6 17.1999L18.6 9.19994Z",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "currentColor"
  }));
}, 'IconCheckCircleFillMedium');
IconCheckCircleFillMedium.displayName = 'IconCheckCircleFillMedium';
export default IconCheckCircleFillMedium;